import axios from "axios";
import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import { push } from "redux-router";
import { toast } from "react-toastify";
import validate from "validate.js";
import constants from "constants";
import actions from "actions";
import storage from "services/storage";
import _ from "lodash";

const {
  API_SUBSCRIPTIONS,
  SUBSCRIBE_WEBINAR_SAGA,
  UNSUBSCRIBE_WEBINAR_SAGA,
  LOAD_SUBSCRIPTIONS_SAGA,
  JOIN_WEBINAR_SAGA,
  JOIN_WEBINAR_FROM_LINK_SAGA,
  JOIN_WEBINAR_FROM_QR_SAGA,
} = constants;

const {
  addRequestError,
  addSubscriptions,
  loadWebinarSaga,
  joinWebinarFromLinkSaga,
  loadWebinarSubscription,
} = actions;

const apiSubscribeWebinar = (webinar_id, registered = false) =>
  axios.post(API_SUBSCRIPTIONS, {
    subscription: {
      webinar_id,
      registered,
    },
  });

const apiUnsubscribeWebinar = (id) =>
  axios.delete(`${API_SUBSCRIPTIONS}/${id}`);

const apiLoadSubscriptions = () => axios.get(API_SUBSCRIPTIONS);

const apiJoinWebinar = (webinar_id) =>
  axios.put(`${API_SUBSCRIPTIONS}/0`, {
    webinar_id,
  });

function* subscribeWebinar({ webinar, registered, source }) {
  try {
    yield call(apiSubscribeWebinar, webinar.id, registered);
    yield put(
      loadWebinarSaga(
        webinar.id,
        false,
        false,
        false,
        false,
        webinar.group_id,
        source
      )
    );
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* unsubscribeWebinar({ id, webinarId, group_id, source }) {
  try {
    yield call(apiUnsubscribeWebinar, id);
    yield put(
      loadWebinarSaga(webinarId, false, false, false, false, group_id, source)
    );
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* loadSubscriptions() {
  try {
    const response = yield call(apiLoadSubscriptions);
    const subscriptions = response.data.subscription;
    yield put(addSubscriptions(subscriptions));
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* joinWebinar({
  webinarId,
  redirect = false,
  handleErrors = false,
  qr = false,
}) {
  try {
    storage.removeJoinWebinarId(null);
    const response = yield call(apiJoinWebinar, webinarId);
    yield put(loadWebinarSaga(webinarId));

    if (!qr) {
      if (redirect) {
        window.location = response.data.subscription.join_url;
      } else {
        if (
          window.webinarTab &&
          response.data &&
          response.data.subscription &&
          response.data.subscription.join_url
        )
          window.webinarTab.location.href = response.data.subscription.join_url;
      }
    } else {
      if (response.data.message) toast.success(response.data.message);
      yield put(push("/"));
    }
  } catch (e) {
    if (handleErrors) {
      toast.warn("Webinar not found");
      yield put(push("/"));
    }
    yield put(addRequestError(e.response));
  }
}

function* _joinWebinarFromLinkSaga({ webinarId }) {
  try {
    const isLogged = yield select((store) => !_.isEmpty(store.users.user));
    if (isLogged) {
      const res = yield call(
        axios.post,
        `api/v1/join_webinar_qrcode?webinar_id=${webinarId}`
      );
      toast.success(res.data.message);
    }
  } catch (e) {}
}

function* joinWebinarFromQRSaga({ webinarId }) {
  try {
    const isLogged = yield select((store) => !_.isEmpty(store.users.user));
    if (isLogged) {
      yield put(joinWebinarFromLinkSaga(webinarId));
      yield put(push("/cpd/live"));
    } else {
      storage.setJoinWebinarId(webinarId);
      toast.warn("To proceed, you must be logged in");
      yield put(push("/users/sign_in"));
    }
  } catch (e) {}
}

// SAGAS
function* __subscribeWebinarSaga() {
  yield takeLatest(SUBSCRIBE_WEBINAR_SAGA, subscribeWebinar);
}

function* __unsubscribeWebinarSaga() {
  yield takeLatest(UNSUBSCRIBE_WEBINAR_SAGA, unsubscribeWebinar);
}

function* __loadSubscriptionsSaga() {
  yield takeLatest(LOAD_SUBSCRIPTIONS_SAGA, loadSubscriptions);
}

function* __joinWebinarSaga() {
  yield takeLatest(JOIN_WEBINAR_SAGA, joinWebinar);
}

function* __joinWebinarFromLinkSaga() {
  yield takeLatest(JOIN_WEBINAR_FROM_LINK_SAGA, _joinWebinarFromLinkSaga);
}
function* __joinWebinarFromQRSaga() {
  yield takeLatest(JOIN_WEBINAR_FROM_QR_SAGA, joinWebinarFromQRSaga);
}

export {
  __subscribeWebinarSaga,
  __unsubscribeWebinarSaga,
  __loadSubscriptionsSaga,
  __joinWebinarSaga,
  __joinWebinarFromLinkSaga,
  __joinWebinarFromQRSaga,
};



// WEBPACK FOOTER //
// ./src/sagas/subscriptions.js